import { toRGBA } from "./utils";

const magilla = [250, 237, 228];
const m = (opacity: number = 1) =>
  toRGBA(magilla[0], magilla[1], magilla[2], opacity);

export default m;
